<div class="main-section container-fluid">
    <p class="languages">Catalán | Español</p>
</div>